import React, { useCallback, useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Outlet, useLocation, useNavigate, useParams } from "react-router";
import MainLayout from "../../components/Common/MainLayout/MainLayout";
import {
  getAllProgramsActionHandler,
  getAllPublishedByMeClassnamesActionHandler,
  getClassByStatusWithConditionActionHandler,
  getShotClassesActionHandler,
  searchProgramDistributeActionHandler,
} from "../../store/actions/actionHandlers/distributeActionHandler";
import { distribute } from "../../utils/mainTabs/distribute/distribute";
import { tileSize } from "../../utils/tileSizes";
import { tileTypes } from "../../utils/tileTypes";
import { distributionHistory } from "../../utils/mainTabs/distribute/distributionHistory";
import { recallShotclasses } from "../../utils/mainTabs/distribute/recallShotclasses";
import { distributeTo } from "../../utils/mainTabs/distribute/distributeTo";
import getTenantName from "../../utils/getTenantName";
import { createSeries } from "../../utils/mainTabs/distribute/createSeries";
import classes from "./DistributePage.module.scss";
import DistributeFooter from "./DistributeFooter/DistributeFooter";
import searchIcon from "../../assets/images/Common/magnifyingGlass.png";
import {
  setCollectionDataAction,
  setSelectedCollectionDataAction,
  setSelectedSeriesDataAction,
  setSelectedShotclassDataAction,
  setSeriesDataAction,
  setShotclassDataAction,
} from "../../store/actions/actionCreators/distributeActionCreator";
import useComponentVisible from "../../hooks/useComponentVisible";
import { FormattedMessage, useIntl } from "react-intl";
import { getRecentlyAddedProgramsActionHandler } from "../../store/actions/actionHandlers/organizeActionHandler";

const DistributePage = () => {
  const pageSize = 10;
  const intl = useIntl();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const location = useLocation();
  const params = useParams();
  const tenantName = getTenantName(dispatch, location);
  const [distributeHeader, setDistributeHeader] = useState("");
  const [distributeTiles, setDistributeTiles] = useState([]);
  const [distributeNavLinks, setDistributeNavLinks] = useState([]);
  const [distributeTileType, setDistributeTileType] = useState(
    tileTypes.DEFAULT
  );
  const [distibuteTileSize, setDistibuteTileSize] = useState(tileSize.DEFAULT);
  const [distributeButtons, setDistributeButtons] = useState([]);
  const [shotClassCount, setShotClassCount] = useState(0);
  const [programCount, setProgramCount] = useState(0);
  const [collectionCount, setCollectionCount] = useState(0);
  const [isStepTile, setIsStepTile] = useState(false);
  const tab = [
    "Classes",
    intl?.formatMessage({ id: "ANALYTICAL_REPORT_PROGRAM" }),
  ];
  const [activeTab, setActiveTab] = useState(
    location?.pathname === distribute.classPath(tenantName) ||
      location?.pathname === distribute.path(tenantName)
      ? tab[0]
      : tab[1]
  );
  const [flag, setFlag] = useState(true);
  const [searchVal, setSearchVal] = useState("");
  const distributeState = useSelector((state) => state.distributeReducer);
  const { selctedShotclassData, selctedSeriesData, originalAllClassNames } =
    distributeState;
  const [allClassNames, setAllClassNames] = useState([]);
  const [ref, isComponentVisible, setIsComponentVisible] =
    useComponentVisible();
  const [loading, setLoading] = useState(false);
  const [programData, setProgramData] = useState([]);

  const getShotclassAndSeriesCount = useCallback(
    (type, setCount) => {
      dispatch(
        getAllProgramsActionHandler("WithoutVTLT", "Published", type, setCount)
      );
    },
    [dispatch]
  );

  useEffect(() => {
    const { name, buttons, path, classPath, seriesPath, collectionPath } =
      distribute;
    if (
      location.pathname === classPath(tenantName) ||
      location.pathname === seriesPath(tenantName) ||
      location.pathname === collectionPath(tenantName) ||
      location.pathname === path(tenantName)
    ) {
      setDistributeHeader(name);
      setDistributeTiles([]);
      setDistributeNavLinks([]);
      setDistributeButtons(buttons(navigate, tenantName));
      setActiveTab(
        location?.pathname === distribute.classPath(tenantName) ||
          location?.pathname === distribute.path(tenantName)
          ? tab[0]
          : tab[1]
      );
      if (location.pathname === path(tenantName))
        navigate(`${distribute.path(tenantName)}/classes`);
      if (flag) {
        setFlag(false);
        getShotclassAndSeriesCount("ShotClass", setShotClassCount);
        getShotclassAndSeriesCount("Program", setProgramCount);
      }
    } else if (location.pathname === distributionHistory.path(tenantName)) {
      setDistributeHeader("");
      setDistributeTiles([]);
      setDistributeNavLinks(distributionHistory.navLinks(navigate, tenantName));
      setDistributeButtons([]);
      setIsStepTile(false);
    } else if (location.pathname === recallShotclasses.path(tenantName)) {
      setDistributeHeader("");
      setDistributeTiles([]);
      setDistributeNavLinks(recallShotclasses.navLinks(navigate, tenantName));
      setDistributeButtons([]);
      setIsStepTile(false);
    } else if (
      location.pathname === distributeTo.path(tenantName) ||
      location.pathname === `${distributeTo.path(tenantName)}/group` ||
      location.pathname ===
        `${distributeTo.path(tenantName)}/distributionList` ||
      location.pathname === `${distributeTo.path(tenantName)}/users`
    ) {
      if (location.pathname === distributeTo.path(tenantName))
        navigate(`${distributeTo.path(tenantName)}/group`);
      const { tiles, navLinks } = distributeTo;
      setDistributeHeader("");
      setDistributeTiles(tiles(navigate, tenantName));
      setDistributeNavLinks(navLinks(navigate, tenantName));
      setDistributeButtons([]);
      setDistributeTileType(tileTypes.DEFAULT);
      setDistibuteTileSize(tileSize.LARGE);
      setIsStepTile(false);
    } else if (
      location.pathname === createSeries.path(tenantName) ||
      location.pathname ===
        createSeries.notificationSettings.path(tenantName) ||
      location.pathname === createSeries.certificateSettings.path(tenantName) ||
      location.pathname === createSeries.distributionDetails.path(tenantName) ||
      location.pathname ===
        `${createSeries.copyPath(tenantName)}/${params?.programId}` ||
      location.pathname ===
        `${createSeries.editPath(tenantName)}/${params?.programId}`
    ) {
      const { navLinks } = createSeries;
      if (location.pathname === createSeries.path(tenantName))
        navigate(`${createSeries.path(tenantName)}/seriesDetails`);
      else if (
        location.pathname ===
        `${createSeries.copyPath(tenantName)}/${params?.programId}`
      )
        navigate(
          `${createSeries.copyPath(tenantName)}/${
            params?.programId
          }/seriesDetails`
        );
      else if (
        location.pathname ===
        `${createSeries.editPath(tenantName)}/${params?.programId}`
      )
        navigate(
          `${createSeries.editPath(tenantName)}/${
            params?.programId
          }/seriesDetails`
        );
      setDistributeHeader("");
      setDistributeNavLinks(navLinks(navigate, tenantName, location, params));
      setDistributeButtons([]);
      setDistributeTileType(tileTypes.DEFAULT);
      setDistibuteTileSize(tileSize.LARGE);
      setIsStepTile(true);
    }
  }, [
    navigate,
    collectionCount,
    programCount,
    shotClassCount,
    dispatch,
    location,
    tenantName,
    params,
    flag,
    getShotclassAndSeriesCount,
  ]);

  const getShotclassAndSeries = useCallback(
    (type) => {
      dispatch(
        getShotClassesActionHandler(
          "WithoutVTLT",
          false,
          "Published",
          type,
          "none",
          "none",
          1,
          pageSize,
          setLoading
        )
      );
    },
    [dispatch]
  );

  useEffect(() => {
    getShotclassAndSeries("ShotClass");
    getShotclassAndSeries("Program");
  }, [dispatch, getShotclassAndSeries]);

  useEffect(() => {
    dispatch(
      getAllPublishedByMeClassnamesActionHandler(
        "WithoutVTLT",
        "Published",
        "Program",
        "none",
        "none",
        1,
        1000,
        setAllClassNames
      )
    );
    dispatch(
      getClassByStatusWithConditionActionHandler(
        "WithoutVTLT",
        "Published",
        0,
        0,
        setAllClassNames
      )
    );
    dispatch(
      getClassByStatusWithConditionActionHandler(
        "WithoutVTLT",
        "PublishedByothers",
        0,
        0,
        setAllClassNames
      )
    );
    dispatch(
      getRecentlyAddedProgramsActionHandler(
        "WithoutVTLT",
        "Published",
        "Program",
        "none",
        "none",
        1,
        1000,
        null,
        null,
        setProgramData
      )
    );
  }, [dispatch]);

  const onSearchClick = (data) => {
    setIsComponentVisible(false);
    const val = data.trim();
    const selectedShotclassIds = selctedShotclassData?.map((data) => {
      return data?.ID;
    });
    const selectedSeriesIds = selctedSeriesData?.map((data) => {
      return data?.ID;
    });
    if (val) {
      setLoading(true);
      dispatch(setShotclassDataAction([]));
      dispatch(setSeriesDataAction([]));
      dispatch(
        searchProgramDistributeActionHandler(
          val,
          "Published",
          "en-GB",
          "WithoutVTLT"
        )
      ).then((response) => {
        if (response?.data) {
          let searchedShotclassData = [],
            searchedSeriesData = [];
          response?.data?.forEach((data) => {
            if (data?.ShotClass) {
              const checked = selectedShotclassIds.includes(
                data?.ShotClass?.ID
              );
              searchedShotclassData = [
                ...searchedShotclassData,
                { ShotClass: { ...data?.ShotClass, checked: checked } },
              ];
            } else if (data?.Programs) {
              const checked = selectedSeriesIds.includes(data?.Programs?.ID);
              searchedSeriesData = [
                ...searchedSeriesData,
                { Programs: { ...data?.Programs, checked: checked } },
              ];
            }
          });
          setShotClassCount(searchedShotclassData?.length);
          setProgramCount(searchedSeriesData?.length);
          setLoading(false);
          if (searchedShotclassData?.length > 0) {
            dispatch(setShotclassDataAction(searchedShotclassData));
          }
          if (searchedSeriesData?.length > 0) {
            dispatch(setSeriesDataAction(searchedSeriesData));
          }
        }
      });
    } else {
      dispatch(setShotclassDataAction([]));
      dispatch(setSeriesDataAction([]));
      getShotclassAndSeries("ShotClass");
      getShotclassAndSeries("Program");
      getShotclassAndSeriesCount("ShotClass", setShotClassCount);
      getShotclassAndSeriesCount("Program", setProgramCount);
    }
  };

  const close = useCallback(() => {
    setIsComponentVisible(false);
  }, [setIsComponentVisible]);

  useEffect(() => {
    setTimeout(() => {
      if (isComponentVisible) {
        window.addEventListener("click", close);
      } else {
        window.removeEventListener("click", close);
      }
    }, 0);
  }, [isComponentVisible, close]);

  const onSearchChange = (e) => {
    const val = e?.target?.value;
    setSearchVal(val);
    if (val?.trim()) {
      let updatedData = [];
      const allNames = [...new Set(allClassNames)];
      setIsComponentVisible(true);
      if (activeTab === tab[0]) {
        allNames?.forEach((shotclass) => {
          if (shotclass.toLowerCase().indexOf(val.toLowerCase()) >= 0)
            updatedData = [...updatedData, shotclass];
        });
      } else {
        programData?.forEach((program) => {
          if (program.toLowerCase().indexOf(val.toLowerCase()) >= 0) {
            updatedData = [...updatedData, program];
          }
        });
      }
      setAllClassNames(updatedData);
    }
    if (!val) {
      setIsComponentVisible(false);
      // dispatch(setShotclassDataAction([]));
      // dispatch(setSeriesDataAction([]));
      setAllClassNames(originalAllClassNames);
      // getShotclassAndSeries("ShotClass");
      // getShotclassAndSeries("Program");
      // getShotclassAndSeriesCount("ShotClass", setShotClassCount);
      // getShotclassAndSeriesCount("Program", setProgramCount);
    }
  };

  useEffect(() => {
    return () => {
      dispatch(setShotclassDataAction([]));
      dispatch(setSeriesDataAction([]));
      dispatch(setCollectionDataAction([]));
      dispatch(setSelectedShotclassDataAction([]));
      dispatch(setSelectedSeriesDataAction([]));
      dispatch(setSelectedCollectionDataAction([]));
    };
  }, []);

  return (
    <MainLayout
      heading={distributeHeader}
      tiles={distributeTiles}
      buttons={distributeButtons}
      navLinks={distributeNavLinks}
      tileType={distributeTileType}
      tileSize={distibuteTileSize}
      isStepTile={isStepTile}
      isOrTextPresent={true}
    >
      <div className={classes.distribute_page}>
        {(location.pathname === distribute?.classPath(tenantName) ||
          location.pathname === distribute?.seriesPath(tenantName) ||
          location.pathname === distribute?.path(tenantName)) && (
          <div className={classes.distribute_page_btns}>
            <ul className={classes.nav}>
              <li
                className={activeTab === tab[0] ? classes.active : ""}
                onClick={() => {
                  setActiveTab(tab[0]);
                  navigate(distribute.classPath(tenantName));
                }}
              >
                Classes ({shotClassCount})
              </li>
              <li
                className={activeTab === tab[1] ? classes.active : ""}
                onClick={() => {
                  setActiveTab(tab[1]);
                  navigate(distribute.seriesPath(tenantName));
                }}
              >
                <FormattedMessage id="PROGRAM_TEXT" /> ({programCount})
              </li>
            </ul>
            <div className={classes.search}>
              {/* <FormProvider {...methods}>
                <Input
                  label={"search"}
                  search
                  name="search"
                  placeholder={"Please enter name or tags to search..."}
                  height="4"
                  borderRadius="5"
                  autoComplete="off"
                />
              </FormProvider> */}
              <input
                className={classes.search_text_input}
                type="text"
                name="search"
                id="search"
                autoComplete="off"
                aria-invalid="false"
                placeholder="Please enter name or tags to search..."
                value={searchVal}
                reference={ref}
                onChange={onSearchChange}
                onKeyDown={(e) => {
                  if (e?.key === "Enter") {
                    onSearchClick(e?.target?.value?.trim());
                  }
                }}
              />
              <img
                src={searchIcon}
                alt="search"
                className={classes.search_icon}
                onClick={() => onSearchClick(searchVal)}
              />
              {allClassNames?.length > 0 && isComponentVisible && (
                <div className={classes.itemList}>
                  {allClassNames?.map((data, index) => (
                    <div
                      className={classes.item}
                      title={data}
                      key={index}
                      onClick={() => {
                        setSearchVal(data);
                        onSearchClick(data);
                        setIsComponentVisible(false);
                      }}
                    >
                      {data?.length > 35 ? data?.slice(0, 35) + "..." : data}
                    </div>
                  ))}
                </div>
              )}
            </div>

            <DistributeFooter tenantName={tenantName} />
          </div>
        )}
        <Outlet
          context={{
            shotClassCount,
            programCount,
            collectionCount,
            setProgramCount,
            setCollectionCount,
            tenantName,
            distributeTiles,
            setDistributeTiles,
            loading,
            setLoading,
          }}
        />
      </div>
    </MainLayout>
  );
};

export default DistributePage;
